import { render } from "./linkSite.vue?vue&type=template&id=cd536c04&scoped=true"
import script from "./linkSite.js?vue&type=script&lang=js"
export * from "./linkSite.js?vue&type=script&lang=js"

import "./linkSite.vue?vue&type=style&index=0&id=cd536c04&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd536c04"]])

export default __exports__